import axiosApi from "../axiosInstance";
import axiosVApi from '../axiovishwam';

export async function getUserTypeList(request) {
  try {
    request = request ? request : {};
    request.userTypeId = request?.userTypeId ?? 0;
    request.userTypeName = request?.userTypeName ?? "";
    request.isActive = request?.isActive ?? null;

    const response = await axiosApi.post(`/UserType/GetUserTypes`, request);
    return response?.data?.data;
  } catch (error) {
    console.log("Error getUserTypeList===>:", error);
    return null;
  }
}

export async function getUserDropdown(request) {
  try {
    const response = await axiosApi.post(`/User/GetUserDropdown`, request);
    return response?.data?.data;
  } catch (error) {
    console.log("Error getUserDropdown===>:", error);
    return null;
  }
}

export async function GetUserManagerDropdown() {
  try {
    const response = await axiosApi.get(`/User/GetManagerDropdown`);
    return response?.data?.data;
  } catch (error) {
    console.log("Error getUserDropdown===>:", error);
    return null;
  }
}

export async function getUsersByFilter(request) {
  try {
    const response = await axiosApi.post(`/User/GetUsersByFilter`, request);
    return response?.data?.data;
  } catch (error) {
    console.log("Error getUsersByFilter===>:", error);
    return null;
  }
}

export async function UserLoginService(request) {
  try {
    // const response = await axiosApi.post(`/UserLogin/UserLoginService`, request);
    // return response?.data;
  } catch (error) {
    console.log("Error UserLoginService===>:", error);
    return null;
  }
}

export async function getUserDetailsByRefrestToken(request) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_VISHWAM_BASE_URL}UserLogin/GetUserDetailsByRefrestToken`,
      {
        method: "POST",
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          "InternalApiKey": "123",
        },
        body: JSON.stringify(request),
      }
    )
      .then(res => res.json())
      .then(data => {
        return data;
      });

    return response;
  } catch (error) {
    console.log("Error GetUserDetailsByRefrestToken===>:", error);
    return error?.response;
  }
}

export async function createNewUser(request) {
  try {
    var response = await axiosApi.post(
      `/AddUserService/CreateNewUser`,
      request,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.log("Error CreateNewUser===>:", error);
    return response?.data;
  }
}

export async function GetUserWiseFeatureMenu(request = {}) {
  try {
    var response = await axiosVApi.post("/UserFeature/GetUserWiseFeatureMenu", request || {});
    return response?.data;
  } catch (error) {
    console.log("Error GetUserWiseFeatureMenu===>:", error);
    return error?.response;
  }
};

export async function GetUserFeaturePermission(request = {}) {
  try {
    var response = await axiosVApi.post("/UserFeature/GetUserFeaturePermission", request || {});
    return response?.data;
  } catch (error) {
    console.log("Error GetUserFeaturePermission===>:", error);
    return error?.response;
  }
};

export async function refreshAccessToken(request) {
  try { 
    
    
    const response = await fetch(
      `${process.env.REACT_APP_API_VISHWAM_BASE_URL}Authentication/RefreshJWTToken`,
      {        
        method: "POST",
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          "InternalApiKey": "123",
        },
        body: JSON.stringify(request),
      }
    )
      .then(res => res.json())
      .then(data => {
        return data;
      });

    return response;
  } catch (error) {
    console.log("Error refreshAccessToken===>:", error);
    return error?.response;
  }
}

